<template>
<div>
    <el-dialog :title="'修改'" :close-on-click-modal="false" width="70%" :visible.sync="viewData.visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
            <div class="des_box">
                <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                    <!-- <el-descriptions-item :span="2" label="SRM协议号:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="priceAgreementCode" style="margin-bottom: 0;">
                            {{dataForm.priceAgreementCode}}
                        </el-form-item>
                    </el-descriptions-item> -->
                    <!-- <el-descriptions-item label="采购组织名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="purchasePartya" style="margin-bottom: 0;">
                            {{getPurchaseOrgName(dataForm.purchasePartya)}}
                        </el-form-item>
                    </el-descriptions-item> -->
                    
                    <!-- <el-descriptions-item label="工厂名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="factoryName" style="margin-bottom: 0;">
                            {{getFactoryName(dataForm.factory)}}
                        </el-form-item>
                    </el-descriptions-item> -->
                    <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="factory" style="margin-bottom: 0;">
                            {{dataForm.factory}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="采购组织:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="purchasePartya" style="margin-bottom: 0;">
                            {{dataForm.purchasePartya}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商编码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="partybCode" style="margin-bottom: 0;">
                            {{dataForm.partybCode}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="supplierPartyb" style="margin-bottom: 0;">
                            {{dataForm.supplierPartyb}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="物料编码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="partCode" style="margin-bottom: 0;">
                            {{dataForm.partCode}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="物料名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="partName" style="margin-bottom: 0;">
                            {{dataForm.partName}}
                        </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>
                <el-table :header-cell-style="{background:'#f5f5f5'}" :data="dataList" size="small" :row-class-name="tableRowClassName" style="width: 100%;" :default-expand-all="false" border >
                    <el-table-column v-if='false' prop="zguid" header-align="center" align="left" label="32位唯一标识">
                    </el-table-column>
                    <el-table-column prop="provisionalEstimate" header-align="center" align="center" label="是否暂估">
                    </el-table-column>
                    <el-table-column prop="sharePriceWithoutTax" header-align="center" align="left" label="净价">
                    </el-table-column>
                    <el-table-column prop="unit" header-align="center" align="left" label="采购单位">
                    </el-table-column>
                    <el-table-column prop="contractStartDate" header-align="center" align="left" label="开始生效日期" :formatter="dateFormat">
                    </el-table-column>
                    <el-table-column prop="contractEndDate" header-align="center" align="left" label="有效截止日期" :formatter="dateFormat">
                    </el-table-column>
                    <el-table-column prop="procurementGroup" header-align="center" align="left" label="采购组">
                    </el-table-column>
                    <el-table-column prop="esokz" header-align="center" align="left" label="采购信息记录分类">
                    </el-table-column>
                    <el-table-column prop="peinh" header-align="center" align="left" label="价格单位">
                    </el-table-column>
                    <el-table-column prop="taxRate" header-align="center" align="left" label="税码">
                    </el-table-column>
                    <el-table-column prop="createTime" header-align="center" align="left" label="创建日期" :formatter="dateFormat1">
                    </el-table-column>
                    <el-table-column prop="updateTime" header-align="center" align="left" label="更新日期" :formatter="dateFormat1">
                    </el-table-column>
                </el-table>
                <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 15px;margin-top: 15px;">
                    <el-descriptions-item label="是否暂估:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="provisionalEstimate" style="margin-bottom: 0;">
                             <el-select size="small" v-model="dataForm.provisionalEstimate">
                                <el-option v-for="item in KOSRT_TYPE" :key="item.value" :label="item.value" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="开始生效日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="contractStartDate" style="margin-bottom: 0;">
                            <el-date-picker v-model="dataForm.contractStartDate" value-format="yyyy-MM-dd" type="date" :clearable="false" :picker-options="pickerOptions0" style="width: 220px">
                            </el-date-picker>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="有效截止日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="contractEndDate" style="margin-bottom: 0;">
                            <el-date-picker v-model="dataForm.contractEndDate" value-format="yyyy-MM-dd" type="date" :clearable="false" :picker-options="pickerOptions1" style="width: 220px">
                            </el-date-picker>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="采购单位:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="unit" style="margin-bottom: 0;">
                             <el-select size="small" v-model="dataForm.unit">
                                <el-option v-for="item in UNIT" :key="item.value" :label="item.value" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="净价:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="sharePriceWithoutTax" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.sharePriceWithoutTax" placeholder="净价"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="价格单位:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="peinh" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.peinh" placeholder="价格单位"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="采购信息记录分类:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="esokz" style="margin-bottom: 0;">
                             <el-select size="small" v-model="dataForm.esokz">
                                <el-option v-for="item in ESOKZ_TYPE" :key="item.value" :label="item.value" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="税码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="taxRate" style="margin-bottom: 0;">
                            <el-select size="small" v-model="dataForm.taxRate">
                                <el-option v-for="(item,index) in taxCodeList" :key="index" :label="item.taxCode" :value="item.taxCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="采购组:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="procurementGroup" style="margin-bottom: 0;">
                            <el-select size="small" v-model="dataForm.procurementGroup">
                                <el-option v-for="(item,index) in procurementList" :key="index" :label="item.positionCode + ':' + item.realName" :value="item.positionCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="责任销售员:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="partyaRepresentive" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.partyaRepresentive"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                   
                    <el-descriptions-item label="供应商电话号码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="supplierTelNumber" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.supplierTelNumber"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="计划交货天数:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="aplfz" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.aplfz"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    
                    <el-descriptions-item label="转换分子:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="conversionMolecule" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.conversionMolecule"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="转换分母:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="conversionDenominator" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.conversionDenominator"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="币别:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="currency" style="margin-bottom: 0;">
                            {{dataForm.currency}}
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="板材结算单位:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="kmein" style="margin-bottom: 0;">
                            <el-input v-model="dataForm.kmein"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>

            </div>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button size="small" plain type="primary" @click="dataFormSubmit()" :loading="loading">
                保存
            </el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    selectPriceAgreementById,
    editPriceAgreementPartList,
    getPriceAgreementListUpdate
} from '@/controller/priceAgreement'
import {
    getPURCHASE_MESSAGE_TYPE_VALUE,
    UNIT,
    KOSRT_TYPE,
    ESOKZ_TYPE
} from '@/utils/const'
import moment, {} from 'moment'
import {
    getSysPositionList
} from '@/controller/sys'
import {
    getFactoryList,
    getTaxCodeList,
    getPurchaseOrgList
} from '@/controller/systemData'
import {
    mapping
} from "@/utils";
export default {
    data() {
        var validateNumber = (rule, value, callback) => {
            if (!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value)) {
                callback(new Error('请输入数字值'))
            } else {
                callback()
            }
        }
        return {
            pickerOptions0: {
                disabledDate: (time) => {
                    return time.getTime() >  new Date(this.dataForm.contractEndDate).getTime();
                }
            },
            pickerOptions1: {
                disabledDate: (time) => {
                    return time.getTime() < new Date(this.dataForm.contractStartDate).getTime()- 1*24*60*60*1000;//减去一天的时间代表可以选择同一天;
                }
            },
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            getPURCHASE_MESSAGE_TYPE_VALUE:getPURCHASE_MESSAGE_TYPE_VALUE,//采购记录信息取对应value
            UNIT:UNIT,//采购单位集合
            KOSRT_TYPE:KOSRT_TYPE,//是否暂估
            ESOKZ_TYPE:ESOKZ_TYPE,//采购信息记录分类
            factoryList:[],//工厂集合
            purchasePartyAList:[],//采购组织
            procurementList:[],//采购组集合
            taxCodeList:[],//税码集合
            dataList:[],//tbale
            dataForm: {
                id:'',//协议号Id
                zguid:'',//32位唯一标识
                partId:'',//零件Id
                priceAgreementCode:'',//SRM协议号
                partybCode:'',// 供应商编码
                supplierPartyb:'',//供应商名称
                partCode:'',//物料号
                partName:'',//物料名称
                sharePriceWithoutTax:'',//净价
                purchasePartya:'',//采购组织
                factory:'',//工厂
                esokz:'', //采购记录分类
                contractStartDate:'',//开始生效日期
                contractEndDate:'',// 有效截至日期
                partyaRepresentive:'',// 责任销售员
                supplierTelNumber:'',// 供应商电话号码
                unit:'',// 采购单位
                aplfz:'',// 计划交货天数
                procurementGroup:'',// 采购组
                taxRate:'',// 税码
                peinh:'',// 价格单位
                syncStatus:'',//同步状态
                provisionalEstimate:'',//是否暂估
                currency:'',//币别
                conversionMolecule:'',// 转换分子
                conversionDenominator:'',// 转换分母
                kmein:'',// 板材结算单位
            },
            dataRule: {
                sharePriceWithoutTax: [{
                    validator: validateNumber,
                    trigger: "blur",
                }],
                peinh: [{
                    validator: validateNumber,
                    trigger: "blur",
                }]
            },
            
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 800
            }
        }
    },
    components: {
    },
    mounted() {},
    methods: {
        init(contract, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.dataForm.partId = contract.partId;
            this.viewData.visible = true
            this.loading = false
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                selectPriceAgreementById({}, this.dataForm.partId).then(data => {
                    if (data && data.code === '00' && data.body) {
                        mapping(data.body, this.dataForm)
                    }
                    this.getDataList(data.body)
                });
                this.getFactoryListVue()
                this.getPurchaseOrgListVue()
                this.getTaxCodeListVue()
                this.getSysPositionListVue()
                
            })
        },
        // 获取数据列表
        getDataList(result) {
            getPriceAgreementListUpdate({
                'purchasePartya': result.purchasePartya,//采购组织
                'partCode': result.partCode,//物料号
                'factory': result.factory,//工厂
                'partybCode': result.partybCode,//供应商编码
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body
                } else {
                    this.dataList = []
                }
            })
        },
        //获取工厂的数据
        getFactoryListVue() {
            getFactoryList({
                post: '',
                address: '',
                factoryDesc: '',
                factoryCode: '',
            }).then((data) => {
                if (data && data.code === '00') {
                this.factoryList = data.body
                }
            })
        },
        // 采购组数据
        getSysPositionListVue() {
            getSysPositionList().then((data) => {
                if (data && data.code === '00') {
                this.procurementList = data.body
                }
            })
        },
        // 采购组织数据
        getPurchaseOrgListVue() {
            getPurchaseOrgList({
                purchaseOrgCode: '',
                purchaseOrgName: '',
            }).then((data) => {
                if (data && data.code === '00') {
                this.purchasePartyAList = data.body
                }
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 1000)
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id':this.dataForm.id,//协议号Id
                        'zguid':this.dataForm.zguid,//唯一标识
                        'partId':this.dataForm.partId,//零件Id
                        'priceAgreementCode':this.dataForm.priceAgreementCode,//SRM协议号
                        'purchasePartya':this.dataForm.purchasePartya,//采购组织
                        'factory':this.dataForm.factory,//工厂
                        'procurementGroup':this.dataForm.procurementGroup,// 采购组
                        'partybCode':this.dataForm.partybCode,// 供应商编码
                        'supplierPartyb':this.dataForm.supplierPartyb,//供应商名称
                        'partCode':this.dataForm.partCode,//物料号
                        'partName':this.dataForm.partName,//物料名称
                        'unit':this.dataForm.unit,// 采购单位
                        'sharePriceWithoutTax':this.dataForm.sharePriceWithoutTax,//净价
                        'peinh':this.dataForm.peinh,// 价格单位
                        'provisionalEstimate':this.dataForm.provisionalEstimate,//是否暂估
                        'contractStartDate':this.dataForm.contractStartDate,//开始生效日期
                        'contractEndDate':this.dataForm.contractEndDate,// 有效截至日期
                        'esokz':this.dataForm.esokz, //采购信息记录分类
                        'taxRate':this.dataForm.taxRate,// 税码
                        'currency':this.dataForm.currency,// 币别
                        'partyaRepresentive':this.dataForm.partyaRepresentive,// 责任销售员
                        'supplierTelNumber':this.dataForm.supplierTelNumber,// 供应商电话号码
                        'aplfz':this.dataForm.aplfz,// 计划交货天数
                        'syncStatus':this.dataForm.syncStatus,// 同步状态
                        'conversionMolecule':this.dataForm.conversionMolecule,// 转换分子
                        'conversionDenominator':this.dataForm.conversionDenominator,// 转换分母
                        'kmein':this.dataForm.kmein,// 板材结算单位
                    }
                    editPriceAgreementPartList(params).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                onClose: () => {
                                    this.loading = false
                                    this.viewData.visible = false
                                    this.$emit('refreshDataList')
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
        //获取税码信息
        getTaxCodeListVue() {
            getTaxCodeList({
                taxCode: "",
                taxRate: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            })
        },
        //通过采购组织code 获取采购组织名称
        getPurchaseOrgName(code) {
            const purchaseOrg = this.purchasePartyAList.find(
                (purchaseOrg) => purchaseOrg.purchaseOrgCode === code
            )
            return purchaseOrg ? purchaseOrg.purchaseOrgName : ''
        },
        // 通过工厂code  获取名字
        getFactoryName(code) {
            const factory = this.factoryList.find(
                (factory) => factory.factoryCode === code
            )
            return factory ? factory.factoryDesc : ''
        },
        // 获取税码的名字
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        //获取采购组对应的name
        getProcurementName(code) {
            const procurementName = this.procurementList.find(procurementName => procurementName.positionCode === code)
            return procurementName ? procurementName.realName : ''
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 392px;'
        },
        //日期格式化
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        //日期格式化
        dateFormat1: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY年MM月DD日")
        },
        tableRowClassName({row, rowIndex}) {
            if (row.partId===this.dataForm.partId) {
                return 'succ-row';
            }
            return '';
        },
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.mb15 {
    margin-bottom: 15px;
}

.button-danger {
    color: #F56C6C
}

.fr {
    float: right;
}

.tab_style {
    min-height: 60vh;
}

</style>
